export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13428.d7f67a88.jpg";